var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPipelinesReverse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6 9C11.6 8.66863 11.3314 8.4 11 8.4C10.6686 8.4 10.4 8.66863 10.4 9H11.6ZM10.5757 22.9243C10.8101 23.1586 11.1899 23.1586 11.4243 22.9243L15.2426 19.1059C15.477 18.8716 15.477 18.4917 15.2426 18.2574C15.0083 18.023 14.6284 18.023 14.3941 18.2574L11 21.6515L7.60589 18.2574C7.37157 18.023 6.99167 18.023 6.75736 18.2574C6.52304 18.4917 6.52304 18.8716 6.75736 19.1059L10.5757 22.9243ZM10.4 9V22.5H11.6V9H10.4Z",
    fill: "#2968C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4 28C20.4 28.3314 20.6686 28.6 21 28.6C21.3314 28.6 21.6 28.3314 21.6 28H20.4ZM20.4 8V28H21.6V8H20.4ZM11.6 11.75V8H10.4V11.75H11.6ZM21.6 8C21.6 4.90721 19.0928 2.4 16 2.4V3.6C18.4301 3.6 20.4 5.56995 20.4 8H21.6ZM11.6 8C11.6 5.56995 13.5699 3.6 16 3.6V2.4C12.9072 2.4 10.4 4.90721 10.4 8H11.6Z",
    fill: "#2968C9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipelinesReverse);
export default __webpack_public_path__ + "static/media/pipelines-reverse.e92c3d626e967e1535f5995c8b5dcc36.svg";
export { ForwardRef as ReactComponent };